import { buildQueryParams } from 'libs/utils'
import { trackHighlight } from './events'

export const name = 'email'

export const getShareUrl = (text, refUrl) => {
  const params = [
    ['subject', 'MasterClass'],
    ['body', `${text}\n\n${refUrl.origin}${refUrl.pathname}`],
  ]

  return `mailto:?${buildQueryParams(params)}`
}

export const action = () => trackHighlight('share-highlight-email')

export const render = (text, rawText, refUrl) => {
  const url = getShareUrl(text, refUrl)

  return `
    <a href="${url}" rel="noopener nofollow noreferrer">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00008 9C7.55397 9 7.16182 9.2955 7.03884
        9.72432C6.91585 10.1531 7.09178 10.6116 7.47009 10.848L15.2051 15.6824C15.6915 15.9864 16.3087
        15.9864 16.7951 15.6824L24.5301 10.848C24.9084 10.6116 25.0843 10.1531 24.9613 9.72432C24.8383
        9.2955 24.4462 9 24.0001 9H8.00008ZM8.53 14.152C8.22173 13.9593 7.83319 13.9491 7.51523
        14.1254C7.19728 14.3016 7 14.6365 7 15V22C7 22.5523 7.44772 23 8 23H24C24.5523 23 25 22.5523
        25 22V15C25 14.6365 24.8027 14.3016 24.4848 14.1254C24.1668 13.9491 23.7783 13.9593 23.47
        14.152L16.53 18.4895C16.2057 18.6922 15.7943 18.6922 15.47 18.4895L8.53 14.152Z" fill="white"/>
      </svg>
    </a>
  `
}
